


import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { routerNames } from '@/common/js/const';
import { documentTypeAllList, depponReimBurseType, iconArr} from '@/common/js/const';
console.log(iconArr)
import regexpValid from '@/common/js/regexp.js';
import { getVATQrcodeContent, setDepponReimBurseType, getDepponReimBurseType } from '@/common/js/common.js';
import conf from './../../config/base.js';
import Box from 'vux/src/components/box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
name: routerNames.SelectReceipt,
directives: {
TransferDom,
},
components: {
Group,
Cell,
Datetime,




XInput,
Box,
CellBox,
XHeader,
Grid,
GridItem,
XButton,
Checker,
CheckerItem,
},
data() {
return {
depponReimBurseType: depponReimBurseType,
dReimBurseType: depponReimBurseType.personal,
source: '',
iconArr:iconArr,
isWechat: ____isWechatBrowser(),
isWxWork: ____isWxWorkBrowser(),
isDing: ____isDingBrowser(),
documentTypeAllList: documentTypeAllList,
/** 需要展示的视图
新增发票分为2步
1 选择 增值税发票、非增值税发票
2 拍照 并编辑票据；如果是增值税票(可识别)，拍照后直接保存服务器；反之，需要编辑票据表单后再保存服务器。
*/
viewStep: 1,
createType: 1, //1表示添加 增值税发票(可识别验真)  0 表示添加 其他发票（不可识别验真）

invoiceInfo: {
no: '',
code: '',
date: '',
checkCode: '',
documentType: '',
},
wxConfig: {
timestamp: '',
nonceStr: '',
signature: '',
},

h5SupportSaoYiSao: false,

showFileListPopup: false,

showOtherInvoice: true,
showScanQrcode: true,

fileListPopupMsg: '',
identificationPermission:true,
imageSlide1: [
{
src: '',
msrc: '',
alt: '',
title: '',
w: 600,
h: 400,
pid: 'image-one',
},
],

validInvoiceCode(val) {
if (regexpValid.invoiceCode(val)) {
return { valid: true, msg: '' };
} else {
return { valid: false, msg: this.$t('10或12位') };
}
},

validInvoiceNo(val) {
if (regexpValid.invoiceNo(val)) {
return { valid: true, msg: '' };
} else {
return { valid: false, msg: this.$t('8位') };
}
},
iconColor: {
iconColor: true,
},
iconColorDisable: {
iconColorDisable: true,
},
};
},
created() {
console.log(this.isWechat)
var $self = this;
window._VueModel = this;

$self.h5SupportSaoYiSao = false;
try {
if (____isAndroid) {

if (typeof eval('window.androidApi.isSupportScan') == 'function') {
$self.h5SupportSaoYiSao = true;
}
} else {
if (typeof eval('window.iosApi.isSupportScan') == 'function') {
$self.h5SupportSaoYiSao = true;
}
}
} catch (error) {
$self.h5SupportSaoYiSao = false;
}
},
activated() {
var $self = this;
/*var br = $self.$route.query.br;
if (conf.autoLoginInfo.source == "deppon" || br == "deppon") {
$self.showOtherInvoice = false;
}

if (conf.autoLoginInfo.source == "shenhua") {
$self.showScanQrcode = false;
}*/
$self.pageLoad();
$self.getJsapiConfig();
$self.getUserSource();
let type = getDepponReimBurseType();
$self.dReimBurseType = type ? type : depponReimBurseType.personal;



},
watch: {
dReimBurseType(newVal, oldVal) {
var $self = this;
try {
setDepponReimBurseType(newVal);
} catch (error) {
console.log(error);
}
},
},
/**计算属性 将状态表中的数据 映射出来*/
computed: {
...mapState({
STATE_InvoiceIndexReload: state => state.invoice.invoiceIndexReload,
}),
isHISUN() {
return this.source === 'HISUN'
},
},
/**初始化的时候调用  类似于 ready */
mounted() {
let idPermission = localStorage.getItem('identificationPermission')
if(idPermission == "null" || idPermission == 'false' || idPermission == null){
idPermission = false
}else{
idPermission = true
}
this.identificationPermission = idPermission
},
methods: {
...mapActions({
ACTION_setPageLoadingTrue: 'common_ac_setPageLoadingTrue',
}),
...mapActions({
ACTION_setPageLoadingFalse: 'common_ac_setPageLoadingFalse',
}),
...mapActions({
ACTION_setInvoiceIndexReload: 'invoice_ac_setinvoiceIndexReload',
}),
getUserSource() {
var $self = this;
$self.$webapi.getUserInfo().then(res => {
if (res.data.status == 1) {
var resData = res.data.result;
if (resData.xfpUser) {
$self.source = resData.xfpUser.source;
if ($self.source == 'deppon') {
$self.showOtherInvoice = false;
}

if ($self.source == 'shenhua') {
$self.showScanQrcode = false;
}
}
}
});
},

getJsapiConfig() {
var $self = this;
if ($self.identificationPermission) {
$self.$webapi.getJsapiSign().then(res => {
window.wx.config({
beta: true,
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: res.data.appId, // 必填，公众号的唯一标识
timestamp: res.data.timestamp, // 必填，生成签名的时间戳
nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
signature: res.data.signature, // 必填，签名，见附录1
jsApiList: [

'chooseImage',
'previewImage',
'uploadImage',
'downloadImage',

'scanQRCode',
'chooseInvoice',
],
});
$self.wxConfig.timestamp = res.data.timestamp;
$self.wxConfig.nonceStr = res.data.nonceStr;
$self.wxConfig.signature = res.data.signature;
});
}
},
pageLoad() {
var $self = this;

var otherPiao = $self.documentTypeAllList.filter(function(item) {
return item.value == 5000 || item.value == 9000;
});

$self.docTypeList = [];

otherPiao.forEach(function(el) {
$self.docTypeList.push({
name: el.name,
value: el.value,
parent: 0,
});

if (el.children && el.children.length > 0) {
el.children.forEach(function(ell) {
$self.docTypeList.push({
name: ell.name,
value: ell.value,
parent: el.value,
});
});
}
});
},
openHelpTip() {
var $self = this;
$self.$router.push('/help/detail/1001');
},

/**
* 01,04（01,04是增值税普通发票，01,01是增值税专用发票，01,11是普通发票(卷)）,
* 01,10-增值税电子普通发票
* 1200153320（发票代码）,
* 07041662（发票号码）,183.49（不含税金额）,20151221（开票日期）,
* 83623873463907646339（校验码）,5080（随机产生的机密信息）
*
* 发票代码 8或12位
* 发票号码8位
* 校验码 20位
*
* 增值税普通发票 01,04,3300164320,30856012,318.10,20180508,11475938679360667598,865b,
* 增值税专用发票 01,01,3100171130,09725707,3773.58,20170630,,EAB,
* 增值税电子普通发票 01,10,031001700311,50756616,1203.77,20180404,11475938679360667598,5EFF,
* 通行费增值税电子普通发票  01,10,011001700112,14280029,4.61,20180111,01916804770189053905,4F16,
* 增值税普通发票(卷票) 01,11,3100173320,30856012,,,,865b,
* 机动车销售统一发票  01,03,150001722060,00871843,118987.18,20180322,,CDA8,
* 二手车销售统一发票
*/
commingSoomTip() {
var $self = this;
$self.$vux.toast.show({
text: $self.$t('即将开通，敬请期待'),
type: 'text',
});
},
/**打开微信相机 */
openWechatCamera(createType) {
var $self = this;
$self.createType = createType;
if(!$self.funJurisdiction(createType)){
return
}
window.wx.ready(function() {
window.wx.chooseImage({
count: 1, // 默认9
sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
success: function(res) {
var localIds = res.localIds; 
window.wx.uploadImage({
localId: localIds[0],
isShowProgressTips: 1,
success: function(data) {
var serverId = data.serverId;
$self.ACTION_setPageLoadingTrue();
$self.$webapi.imageUploadForWechat(serverId, $self.createType).then(res => {
if (res.data.status == 1) {

$self.ACTION_setInvoiceIndexReload({
type: '2',
reserve: '',
});

if ($self.createType == 0 && res.data.result) {

setTimeout(function() {
$self.ACTION_setPageLoadingFalse();
$self.$router.replace({
path: '/invoice/update/' + res.data.result,
query: { createType: '0' },
}); //createType标识发票编辑页面分类 0-其他票据（不可识别） 1-增值税票税（可识别） 2-全部
}, 400);
} else {
$self.ACTION_setPageLoadingFalse();
$self.$vux.alert.show({
title: $self.$t('文件提交成功'),
content: $self.$t('增值税发票上传成功'),
onShow() {},
onHide() {},
});
}
} else {
$self.ACTION_setPageLoadingFalse();

$self.$vux.alert.show({
title: $self.$t('提示'),
content: res.data.msg,
onShow() {},
onHide() {},
});
}
});
},
});
},
});
});
},

openFile($event, documentType) {
if(!this.funJurisdiction(documentType)){
return
}
var $self = this;
$self.imageSlide1.length = 0;
$self.fileListPopupMsg = '';

var fileLength = $event.target.files.length;



var successOprateCount = 0;

var errorOprateCount = 0;


if ($event.target.files && $event.target.files[0]) {




for (var i = 0; i < $event.target.files.length; i++) {
var el = $event.target.files[i];
lrz(el, {
width: 1920,
height: 1080,
quality: 0.85,
})
.then(function(rst) {


if (rst.base64Len > 1024 * 1024 * 0.9) {
console.log('图片不能超过900KB');
errorOprateCount++;
if (errorOprateCount + successOprateCount == fileLength) {
var tempFiles = $self.imageSlide1.map(function(elllll) {
return elllll.src;
});
$self.uploadMultiFiles(tempFiles, documentType);
}
return false;
}
successOprateCount++;
$self.imageSlide1.push({
src: rst.base64,
msrc: rst.base64,
alt: '',
title: '',
w: 800,
h: 600,
pid: 'image-one',
});

if (errorOprateCount + successOprateCount == fileLength) {
var tempFiles = $self.imageSlide1.map(function(elllll) {
return elllll.src;
});
$self.uploadMultiFiles(tempFiles, documentType);
}
})
.catch(function(err) {
console.log('压缩图片失败');
errorOprateCount++;
if (errorOprateCount + successOprateCount == fileLength) {
var tempFiles = $self.imageSlide1.map(function(elllll) {
return elllll.src;
});
$self.uploadMultiFiles(tempFiles, documentType);
}
});
}
} else {
$self.$vux.toast.show({
text: $self.$t('选取发票失败'),
type: 'text',
});
}
},
discernOther(createType,imgId){

if (createType == '90009999' && imgId) {
this.ACTION_setPageLoadingFalse();
this.$router.replace({
path: '/invoice/update/' + imgId,
query: {createType: '0'},
});
this.ACTION_setPageLoadingFalse();
return true
}else{
false
}
},
uploadMultiFiles(arrBase64File, documentType) {
var $self = this;
if (arrBase64File.length == 0) {
$self.$vux.toast.show({
text: $self.$t('发票影像列表是空的，无法上传'),
type: 'text',
});
return false;
}
var successCount = 0;
var errorCount = 0;
arrBase64File.forEach(function(el) {
$self.ACTION_setPageLoadingTrue();
var parms = {
documentType: documentType,
};


if (documentType == '30001001') {
parms.pdfFile = el;
} else {
parms.imageFile = el;
}

if ($self.source === 'deppon' && $self.dReimBurseType === depponReimBurseType.BP) {
parms.status = '-1';
} else {
parms.status = '0';
}
$self.$webapi.createInvoice(parms).then(res => {
if($self.discernOther(documentType,res.data.result) == true){
return
}
$self.ACTION_setPageLoadingFalse();
if (res.data.status == 1) {
successCount++;
} else {
errorCount++;
}
if (successCount + errorCount == arrBase64File.length) {
$self.$vux.alert.show({
title: $self.$t('操作成功'),
content: $self.$t('共上传') + successCount + $self.$t('个发票影像'),
onShow() {},
onHide() {},
});

$self.ACTION_setInvoiceIndexReload({
type: '2',
reserve: '',
});
}
});
});
},

pageGoBack() {
this.$router.push('/invoice/create');

},

scanCallback(result) {
var $self = this;
if (result == null || result == undefined || result == '') {
$self.$vux.toast.show({
text: $self.$t('二维码错误,请扫描发票上的二维码'),
type: 'text',
});
return false;
}
if (result.indexOf('http://') > -1 || result.indexOf('https://') > -1 || result.indexOf('www.') > -1) {

if ($self.identificationPermission) {
location.href = result;
} else {
$self.$vux.toast.show({
text: $self.$t('二维码错误,请扫描发票上的二维码'),
type: 'text',
});
}
return false;
}

var tempInvoice = getVATQrcodeContent(result);
if (tempInvoice == null) {
$self.$vux.toast.show({
text: $self.$t('二维码错误,请扫描发票上的二维码'),
type: 'text',
});
return false;
}

var vmodel = {
invoiceCode: tempInvoice.code,
invoiceNo: tempInvoice.no,
paperDrewDate: tempInvoice.date,
amountWithoutTax: tempInvoice.totalAmount,
checkCode: tempInvoice.checkCode,
documentType: tempInvoice.documentType,
};


if (vmodel.documentType == '40001001') {
/*卷票 填写表单
卷票扫描后  只有发票代码 发票号码   需要补充填写  日期和 校验码 在提交 */
$self.$router.push({
path: '/invoice/createJuan',
query: {
no: tempInvoice.no,
documentType: tempInvoice.documentType,
code: tempInvoice.code,
},
});
return false;
}

if (vmodel != null) {
$self.ACTION_setPageLoadingTrue();

if ($self.source === 'deppon' && $self.dReimBurseType === depponReimBurseType.BP) {
vmodel.status = '-1';
} else {
vmodel.status = '0';
}
$self.$webapi.createInvoice2(vmodel).then(res => {
$self.ACTION_setPageLoadingFalse();
if (res.data.status == 1) {
$self.$vux.alert.show({
title: $self.$t('操作成功'),
content: $self.$t('增值税发票上传成功'),
onShow() {},
onHide() {},
});


$self.ACTION_setInvoiceIndexReload({
type: '2',
reserve: '',
});
} else {
$self.$vux.toast.show({
text: res.data.msg,
type: 'text',
});
}
});
}
},
saoyisao() {
var $self = this;
if ($self.isWechat || $self.isWxWork) {

$self.$vux.alert.show({
title: this.$t('提示'),
content: this.$t('扫二维码添加的发票无照片！如须保存照片，请选择其他方式'),
onShow() {},
onHide() {
window.wx.ready(function() {
window.wx.scanQRCode({
needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
desc: 'scanQRCode desc',
success: function(res) {

var result = res.resultStr; 
$self.scanCallback(result);
},
});
});
},
});
} else if ($self.isDing) {
dd.biz.util.scan({
type: 'qrCode', // type为qrCode(二维码)、barCode(条形码)、all(全部)。
onSuccess: function(data) {

/* data结构
{ 'text': String}
*/

var result = data.text;
$self.scanCallback(result);
},
onFail: function(err) {
$self.$vux.toast.show({
text: $self.$t('扫一扫上传失败！'),
type: 'text',
});
},
});
} else {

try {
if (____isAndroid) {
if ($self.source == 'futureland') {
window.location.href = 'xinchengscan://window.androidApi.openScan';
} else {
window.androidApi.openScan('扫描二维码');
}
} else {
if ($self.source == 'futureland') {
window.location.href = 'xinchengscan://window.iosApi.openScan';
} else {
window.iosApi.openScan('扫描二维码' + new Date().getTime(), function(result) {
$self.scanCallback(result);
});
}
}
} catch (error) {

$self.$vux.toast.show({
text: $self.$t('该终端不支持扫一扫功能'),
type: 'text',
});
}
}
},
funJurisdiction(type){

if(this.identificationPermission || type == '90009999' || type == '0' ){
return true
}else{
this.$vux.toast.show({
text: this.$t('该功能暂未开放'),
type: 'text',
});
return false
}
}
},
};


window.scanCallBack = function(e) {



let result = e.result ? e.result : e;
window._VueModel.scanCallback(result);
};

window.addEventListener('scanCallBack', scanCallBack);
